// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-redesign-template-js": () => import("./../../../src/templates/redesign_template.js" /* webpackChunkName: "component---src-templates-redesign-template-js" */)
}

